import React from "react";
import "./Legal.css";
import { FiUserCheck, FiShield, FiAlertTriangle, FiBookOpen, FiLock } from "react-icons/fi";
import { FileText } from "lucide-react";

export default function TermsOfService() {
  const legalId = "BAILCP-V-TOS-2.2";
  const lastUpdated = "December 5, 2025";

  return (
    <div className="legal-page">

      {/* Header */}
      <div className="legal-header">
        <FileText className="legal-header-icon" />
        <h1>Terms of Service</h1>
        <p className="legal-subtext">
          By accessing BodhAI, you agree to the following terms ensuring a safe, secure, and responsible experience.
        </p>
      </div>

      {/* Meta Info */}
      <div className="legal-meta">
        <span className="legal-id">Legal ID: {legalId}</span>
        <span className="legal-updated">Last Updated: {lastUpdated}</span>
      </div>

      {/* Section 1 */}
      <div className="legal-section">
        <h2><FiBookOpen className="legal-icon" /> Acceptance of Terms</h2>
        <ul>
          <li>By using the BodhAI platform, you agree to follow all terms, laws, and policies.</li>
          <li>If you do not agree, you must stop using the platform immediately.</li>
          <li>BodhAI may update these terms. Continued use means acceptance.</li>
          <li>You must be at least 13 years old or the legal age in your region.</li>
        </ul>
      </div>

      {/* Section 2 */}
      <div className="legal-section">
        <h2><FiUserCheck className="legal-icon" /> User Accounts & Responsibilities</h2>
        <ul>
          <li>You must keep your login credentials secure.</li>
          <li>Provide accurate and updated information during registration.</li>
          <li>Do not share or transfer your account.</li>
          <li>BodhAI may suspend accounts that violate these terms.</li>
        </ul>
      </div>

      {/* Section 3 */}
      <div className="legal-section">
        <h2><FiShield className="legal-icon" /> Acceptable Use Policy</h2>
        <ul>
          <li>No unlawful, malicious, or harmful activity.</li>
          <li>No unauthorized attempts to access any systems.</li>
          <li>No malware, spam, or harmful material distribution.</li>
          <li>No automated data scraping or extraction tools.</li>
        </ul>
      </div>

      {/* Section 4 */}
      <div className="legal-section">
        <h2><FiLock className="legal-icon" /> Intellectual Property</h2>
        <ul>
          <li>BodhAI owns all content, features, and platform rights.</li>
          <li>Do not copy, resell, or modify platform resources.</li>
          <li>User-generated content stays yours but allows BodhAI usage rights.</li>
          <li>Trademarks and branding belong to respective owners.</li>
        </ul>
      </div>

      {/* Section 5 */}
      <div className="legal-section">
        <h2><FiAlertTriangle className="legal-icon" /> Limitation of Liability</h2>
        <ul>
          <li>BodhAI is provided “as-is” with no warranties.</li>
          <li>We are not liable for indirect or consequential damages.</li>
          <li>Maximum liability is limited to your last 12-month payments.</li>
          <li>Some jurisdictions may not allow these limitations.</li>
        </ul>
      </div>

      {/* Footer */}
      <div className="legal-footer">
        Have questions? Contact our legal team at{" "}
        <a href="mailto:legal@bodhai.com">legal@bodhai.com</a>
      </div>

    </div>
  );
}
